import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { gridSize } from '@atlaskit/theme/constants';
import { multiply } from '@atlaskit/theme/math';
/**
 * Provide a styled container for form headers.
 */
export var FormFooterWrapper = styled.footer(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: ", "px;\n  display: flex;\n  justify-content: ", ";\n"], ["\n  margin-top: ", "px;\n  display: flex;\n  justify-content: ",
    ";\n"])), multiply(gridSize, 3), function (props) {
    return props.align === 'start' ? 'flex-start' : 'flex-end';
});
var templateObject_1;
//# sourceMappingURL=FormFooter.js.map